import React from 'react';
import { Tag, Typography } from 'antd';
import { Button } from '../../../design-system';
import PreferenceControls from './PreferenceControls';

const { Text } = Typography;

const EventRow = ({
    event,
    availableChannels,
    frequencies,
    onSave,
    onReset,
    saving = false,
}) => {
    const hasOverride = event.override !== null && event.override !== undefined;

    return (
        <div className="notification-preferences__event-row">
            <div className="notification-preferences__event-row-header">
                <Text strong>{event.displayName}</Text>
                {hasOverride && <Tag color="gold">Override</Tag>}
                {!event.isBatchable && (
                    <Text type="secondary" style={{ fontSize: 12 }}>
                        Always immediate
                    </Text>
                )}
            </div>

            {event.description && (
                <div className="notification-preferences__event-row-description">
                    <Text type="secondary">{event.description}</Text>
                </div>
            )}

            <div className="notification-preferences__event-row-controls">
                <PreferenceControls
                    value={event.effectivePreference}
                    availableChannels={availableChannels}
                    frequencies={frequencies}
                    onSave={(body) => onSave(event.eventKey, body)}
                    saving={saving}
                />
            </div>

            {hasOverride && (
                <div className="notification-preferences__event-row-reset">
                    <Button
                        variant="secondary"
                        size="small"
                        uppercase={false}
                        onClick={() => onReset(event.eventKey)}
                        disabled={saving}
                    >
                        Reset to category default
                    </Button>
                </div>
            )}
        </div>
    );
};

export default EventRow;
